export interface MoldDifferentiation {
  description: string;
  value: string;
  unit: string;
  overgrown: boolean;
}

export function newMoldDifferentiation(): MoldDifferentiation {
  return { description: "", value: "", unit: "", overgrown: false };
}
